import axios from 'axios';
import { message } from 'antd';
import React, { Component } from 'react';
import { AppInsights } from "applicationinsights-js";
import { msalInstance } from "../index";

const managementApiClient = () => {
    const defaultOptions = {
        headers: {
            'Content-Type': 'application/json',
        },
    };
    //get the scope url from the 'API permissions' of the app-registration in AD (select line => right-side shows the full url)
    const authenticationParameters = {
        scopes: ['https://BallastNedam.onmicrosoft.com/f1ecc4a1-5b29-441b-a4a0-45e8993ece35/user_impersonation']
    }

    let instance = axios.create(defaultOptions);

    // Set the AUTH token for any request
    instance.interceptors.request.use(async (config) => {
        const account = msalInstance.getActiveAccount();
        if (!account) {
            throw Error("No active account! Verify a user has been signed in and setActiveAccount has been called.");
        }
        try {
            const token = await msalInstance.acquireTokenSilent({
                ...authenticationParameters,
                account: account
            });
            config.headers.Authorization = `Bearer ${token.accessToken}`;
            return config;
        } catch (error) {
            console.log('Msal error getting token. trying redirect...');
            try {
                const token = await msalInstance.acquireTokenRedirect({
                    ...authenticationParameters,
                    account: account
                });
                config.headers.Authorization = `Bearer ${token.accessToken}`;
                return config;
            } catch {
                console.log('Msal error getting token:', error);
            }
        }
    }, (error) => {
        return error;
    });

    instance.interceptors.response.use(response => {
        return response;
    }, error => {
        if (error.response.status === 401) {
            message.error(<span style={{ color: 'red' }}>'Unauthorized request, no rights...'</span>);
        }
        AppInsights.trackException(error);
        return error;
    });

    return instance;
};

export default managementApiClient();